import styled from '@emotion/styled';
import React from 'react';
import NumberFormat from 'react-number-format';
import { Input } from '../Input';
import type { INumberFormatInputProps } from '../number-input/NumberFormatInput';

const Host = styled.div``;

const FormattedInput = styled(Input)`
  text-align: center;
  width: 100%;
`;
export function KennitalaInput({
  inputSize,
  input,
  value,
  ...rest
}: INumberFormatInputProps) {
  return (
    <Host>
      <NumberFormat
        customInput={input ?? FormattedInput}
        displayType="input"
        format={
          value !== undefined && value !== null && value?.toString().length > 6
            ? '######-####'
            : undefined
        }
        inputSize={inputSize}
        value={value}
        {...rest}
      />
    </Host>
  );
}
